import script from "./TableValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableValue.vue?vue&type=script&setup=true&lang=ts"

import "./TableValue.vue?vue&type=style&index=0&id=178d0c58&lang=scss"

const __exports__ = script;

export default __exports__